export const NON_BILLABLE_VALUE =
  "Non-billable - The client is not expected to repay the cost of the expense.";
export const BILLABLE_VALUE =
  "Billable - The client is expected to repay the cost of the expense.";
